<li class="pt--4" *ngIf="section" style="display: block">
  <section class="pl--4 pb--2">
    <span class="section tt--uppercase f--6 bold" style="cursor: default">
      {{ section.title }}
    </span>
  </section>

  <ul *ngIf="section.subsections as subsections">
    <ta-subsection
      *ngFor="let subsection of sortSubsections(subsections)"
      [subsection]="subsection"
      [active]="currentSubsectionId === subsection.id"
      (click)="handleSubsectionClick(subsection.id)"
    >
    </ta-subsection>
  </ul>
</li>
